/*@ngInject*/
const OrganizationUtil = function (organizationType) {

    var organizationTypeToOrganizationTypeString = {};
    organizationTypeToOrganizationTypeString[organizationType.AGENCY] = organizationType.AGENCY_STRING;
    organizationTypeToOrganizationTypeString[organizationType.CARRIER] = organizationType.CARRIER_STRING;
    organizationTypeToOrganizationTypeString[organizationType.MGA_AGENCY] = organizationType.MGA_AGENCY_STRING;
    organizationTypeToOrganizationTypeString[organizationType.MGA_CARRIER] = organizationType.MGA_CARRIER_STRING;

    this.getOrganizationTypeString =  function (type) {
        return organizationTypeToOrganizationTypeString[type];
    };

    this.getTitleFromStateParam = function (paramOrganizationType) {
        var agency = 'organization.manageAgencies',
            carrier = 'organization.manageCarriers',
            mgaAgency = 'organization.manageMGAAgencies',
            mgaCarrier = 'organization.manageMGACarriers',
            result;

        switch (paramOrganizationType) {
            case organizationType.AGENCY:
                result = agency;
                break;
            case organizationType.CARRIER:
                result = carrier;
                break;
            case organizationType.MGA_AGENCY:
                result = mgaAgency;
                break;
            case organizationType.MGA_CARRIER:
                result = mgaCarrier;
                break;
        }

        return result;
    };

    this.getOwnerUri = function (type, organizationId) {
        var agency = 'com.firstbest.underwriting.agent.Agency:',
            carrier = 'com.firstbest.underwriting.carrier.Carrier:',
            result;

        type = parseInt(type);

        switch (type) {
            case organizationType.AGENCY:
            case organizationType.MGA_AGENCY:
                result = agency;
                break;

            case organizationType.CARRIER:
            case organizationType.MGA_CARRIER:
                result = carrier;
                break;
        }

        result += !_.isNil(organizationId) ? organizationId : organizationTypeToOrganizationTypeString[type];

        return result;
    };

    this.isValidNavigationItem = function (item) {
        return item.formTemplateAllowDirectNavigation && item.root;
    };
};

angular.module('ums.configuration')
    .service('organizationUtil', OrganizationUtil);
